import { render, staticRenderFns } from "./duo_question_note.vue.js?vue&type=template&id=f9a86568&vue3!=!../../../../../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./duo_question_note.vue?vue&type=template&id=f9a86568&vue3"
import script from "./duo_question_note.vue.js?vue&type=script&lang=js&vue3!=!../../../../../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./duo_question_note.vue?vue&type=script&lang=js&vue3"
export * from "./duo_question_note.vue.js?vue&type=script&lang=js&vue3!=!../../../../../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./duo_question_note.vue?vue&type=script&lang=js&vue3"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports